import { IBaseModel, BaseModel } from "../base.model";

export interface IReceptionSectionListingViewModel extends IBaseModel { }
export class ReceptionSectionListingViewModel extends BaseModel implements IReceptionSectionListingViewModel { }


// WEBPACK FOOTER //
// ./src/models/reception/reception-sections-listing.viewmodel.ts